import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';

@Component({
  selector: 'app-auth-callback',
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
})
export class AuthCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private router = inject(Router);
  ngOnInit(): void {
    // Escuchamos los parámetros de la URL
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];

      if (token) {
        // 1. Guardar el token en el almacenamiento local
        localStorage.setItem('access_token', token);
        this.authService.miInformacion().subscribe(); // Cargar información del usuario con el token
        // 2. Redirigir al dashboard o inicio
        // Usamos replaceUrl: true para que el usuario no pueda volver atrás a esta ruta
        this.router.navigate(['/sistema'], { replaceUrl: true });
      } else {
        // Si no hay token, mandamos al login con un error
        console.error('No se recibió token de Google');
        this.router.navigate(['/login']);
      }
    });
  }
}
